import Lien from './Lien';

export default Lien;
